"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function DollarCalendar16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("g", { id: "DollarCalendar16" },
            react_1.default.createElement("g", { id: "icon" },
                react_1.default.createElement("path", { d: "M3 1H5V3H11V1H13V3H15V5H3V13H9V15H1V3H3V1Z", fill: "#131416" }),
                react_1.default.createElement("path", { d: "M6 6V8H4V6H6Z", fill: "#131416" }),
                react_1.default.createElement("path", { d: "M6 9V11H4V9H6Z", fill: "#131416" }),
                react_1.default.createElement("path", { d: "M9 6H7V8H9V6Z", fill: "#131416" }),
                react_1.default.createElement("path", { d: "M12 6.5C12 6.22386 12.2239 6 12.5 6C12.7761 6 13 6.22386 13 6.5V7.26562C13.7322 7.36651 14.3346 7.69433 14.8005 8.11333L14.2019 9.31333C13.8615 8.91333 13.216 8.56667 12.5235 8.56667C11.9836 8.56667 11.6315 8.83333 11.6315 9.19333C11.6315 9.54959 12.1085 9.65848 12.7036 9.7943C13.6898 10.0194 15 10.3185 15 11.94C15 13.0042 14.2825 13.8111 13 13.9663V14.5C13 14.7761 12.7761 15 12.5 15C12.2239 15 12 14.7761 12 14.5V13.9566C11.2135 13.8484 10.4892 13.5054 10 12.9933L10.6455 11.7667C11.0681 12.22 11.9014 12.66 12.6056 12.66C13.2512 12.66 13.5563 12.38 13.5563 11.98C13.5563 11.5671 13.0404 11.4492 12.4131 11.3059C11.4403 11.0836 10.1995 10.8002 10.1995 9.26C10.1995 8.31291 10.8313 7.46836 12 7.27483V6.5Z", fill: "#131416" }))));
}
function DollarCalendar16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(DollarCalendar16Svg, Object.assign({}, svgProps)));
}
exports.default = DollarCalendar16;
//# sourceMappingURL=DollarCalendar16.js.map